

import { StyledSvg } from './svg-icon.style';
import { mergeProps, useContext } from 'solid-js';
import { theme } from '../../style/theme';
import { SvgIconProps, SvgIconStyledProps } from './svg-icon.d';
import { AppContext } from '../../app-context-provider/app-context-provider';

const defaultProps: SvgIconStyledProps = {
    xmlns: 'http://www.w3.org/2000/svg',
    backgroundOpacity: 0,
    version: '1.1',
    x: '0px',
    y: '0px',
    viewBox: '0 0 30 30',
    height: 2.14,
    width: 2.14,
    padding: '',
    fill: theme.colors.svg.default,
    opacity: 1,
};

export const SvgIcon = (componentProps: SvgIconProps) => {
    const { localize } = useContext(AppContext);
    
    const props = mergeProps(defaultProps, componentProps);

    // if (componentProps.defaultAriaLabel === 'Quote Close Icon') {
    //     console.log('props', props);
        
    //     // console.log('asdfa', localize(componentProps.ariaLabel || '', componentProps.ariaLabel || ''));
    // }

    const getAltText = () => {
        // If an aria label is provided, use it
        if (componentProps.ariaLabel) {
            return componentProps.ariaLabel;
        }

        // Use the icon's default aria label, localized
        return localize(componentProps.defaultAriaLabel, componentProps.defaultAriaLabel);
    };

    return (
        <StyledSvg {...props} aria-label={getAltText()} aria-hidden={props.ariaHidden || false}>
            { componentProps.children }
        </StyledSvg>
    );
};
